import React from 'react'
import { Bounds } from 'src/types/map'

type MapContextProps = {
  config: {
    enable: () => void
    disable: () => void
  }
  fitToBounds: (bounds: Bounds) => void
  mapType: 'builder' | 'main'
}

export const MapContext = React.createContext<MapContextProps>({
  config: {
    enable: () => {},
    disable: () => {},
  },
  fitToBounds: () => {},
  mapType: 'builder',
})

export const useMapContext = () => {
  const result = React.useContext(MapContext)
  if (!result) {
    throw new Error('No MapEditorContextProvider found')
  }
  return result
}
